import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Box, Typography, IconButton, List, ListItem, ListItemText, ListItemIcon, Divider, Hidden, Drawer } from '@material-ui/core'
import LogoImage from '../../Assets/Icons/Logo.png'
import { headerStyles } from './style'
import { getNav } from './constants'
import { Avatar, Popover } from '@material-ui/core'
import { userSignOut } from '../../AppRedux/actions/Auth'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useHistory, NavLink, useLocation } from 'react-router-dom'
import MenuIcon from '@material-ui/icons/Menu'
import DashboardIcon from '@material-ui/icons/Dashboard'
import AssignmentIcon from '@material-ui/icons/Assignment'
import Contact from '../../Components/Contact'
import _ from 'lodash'

function Header(props) {
  const classes = headerStyles()
  const history = useHistory()
  const location = useLocation()
  const nav = getNav(props.isSuperAdmin, props.currentUser, props.isViewOnly)
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const [openSupport, setOpenSupport] = useState(false)

  const activeRoute = (routeName) => {
    return location.pathname.startsWith(routeName) ? true : false
  }

  const renderNav = (obj) => {
    return (
      <NavLink className={classes.nav} to={obj.url} activeStyle={{ fontWeight: 'bold' }}>{obj.title}</NavLink>
    )
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  const drawer = (
    <>
      <Divider />
      <Box className={classes.headerBar}>
        <Box className={classes.drawerLogoDiv}>
          <img src={LogoImage} className={classes.logoImage} alt='logo' />
          <Typography className={classes.title}>Grid Services Manager</Typography>
        </Box>
      </Box>
      <List>
        {nav.map((obj, index) => (
          <div onClick={() => setMobileOpen(false)}>
            <NavLink to={obj.url} className={classes.navmd} key={obj.title}>
              <ListItem button className={activeRoute(obj.url) ? classes.active : ''}>
                <ListItemIcon>{index % 2 === 0 ? <DashboardIcon color="primary" /> : <AssignmentIcon color="primary" />}</ListItemIcon>
                <ListItemText primary={obj.title.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase() })} />
              </ListItem>
            </NavLink>
          </div>
        )
        )}
      </List>
    </>
  )

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  return (
    <Box className={classes.headerBar}>
      <Contact open={openSupport} handleClose={() => setOpenSupport(false)} />
      {props.isSignedInUser && (
        <>
          <Hidden mdUp implementation="css">
            <IconButton
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
          </Hidden>
          <Hidden mdUp implementation="css">
            <Drawer
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
              ModalProps={{
                keepMounted: true,
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
        </>
      )}
      <Box className={classes.logoDiv}>
        <img src={LogoImage} className={classes.logoImage} alt='logo' />
        <Typography className={classes.title}>Grid Services <br /> Manager</Typography>
      </Box>
      {props.isSignedInUser && (
        <>
          <Hidden smDown >
            <Box className={classes.navWrapper}>
              {nav.map(renderNav)}
            </Box>
          </Hidden>

          <div className={classes.avatarContainer}>
            <ExpandMoreIcon className={classes.avatarIcon} onClick={handleClick} />
            <Avatar className={classes.avatar} src="/broken-image.jpg" onClick={handleClick} />
            <Popover
              id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              PaperProps={{
                className: classes.headerPaper,
              }}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Box p={1}>
                <Typography className={`${classes.heading}`} align="center">{(props.currentUser && props.currentUser.account_company_name) || 'Enphase'}</Typography>
                <Typography className={classes.popoverName} align="center">{props.currentUser.user_name}</Typography>
                <Typography className={classes.popoverName} align="center">{props.isSuperAdmin ? 'SuperAdmin' : props.isAdmin ? 'Account Admin' : props.isViewOnly ? 'View Only' : 'Account User'}</Typography>
              </Box>
              <Divider />
              <Typography className={classes.typography} onClick={() => { history.push('/accounts'); handleClose() }}>My Accounts</Typography>
              <Typography className={classes.typography}><a className={classes.linkStyle} href="mailto:gridservices@enphase.com" target="_blank">Contact Support</a></Typography>
              <Typography className={classes.typography} onClick={() => { props.userSignOut(props.currentUser); localStorage.setItem('signedOut', '1') }}>Sign Out</Typography>
            </Popover>
          </div>
        </>
      )
      }
    </Box >
  )
}

const mapStateToProps = ({ auth }) => {
  const { authUser, currentUser, isSuperAdmin, isAdmin, isViewOnly } = auth
  return { authUser, currentUser, isSuperAdmin, isAdmin, isViewOnly }
}

const mapDispatchToProps = dispatch => ({
  userSignOut: payload => dispatch(userSignOut(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(Header)